import {
  InnosErrorBoundary,
  RichAppIconProps
} from '@inno-tools/container-bridge'
import { useFederatedComponent } from 'modules/app-registry/hooks/useFederatedComponent'

const TimeTrackingRichAppIconContent: React.FC<RichAppIconProps> = props => {
  const { module, isLoaded, isError, missingRemoteUrl } = useFederatedComponent(
    process.env.REACT_APP_TIMETRACKING_APP_DEV_PATH,
    'timetracking',
    './TimeTrackingRichAppIcon',
    'timeTrackingApp'
  )

  // @ts-expect-error: dynamic import
  const { TimeTrackingRichAppIcon } =
    isLoaded && !isError && !missingRemoteUrl && module
      ? module
      : {
          TimeTrackingRichAppIcon: () => null
        }
  return <TimeTrackingRichAppIcon {...props} />
}

export const TimeTrackingRichAppIcon: React.FC<RichAppIconProps> = props => (
  <InnosErrorBoundary>
    <TimeTrackingRichAppIconContent {...props} />
  </InnosErrorBoundary>
)
